export default "__VITE_ASSET__3sSrzxFO__"